import { Maybe, ResourceContent } from "@examspark/types";

export const parseItemCanvas = <
  T extends { content?: Maybe<{ canvas?: Maybe<ResourceContent["canvas"]> }> },
>(
  draft: Maybe<T> | undefined,
) => {
  if (draft?.content?.canvas) {
    draft.content.canvas.forEach((el) => {
      if (typeof el?.config === "string") el.config = JSON.parse(el.config);
      if (typeof el?.content === "string") el.content = JSON.parse(el.content);
      if (typeof el?.scoring === "string") el.scoring = JSON.parse(el.scoring);
    });
  }
};
